import { useFetchLatestAppoinmentResults } from '@/api/hooks/useFetchLatestAppointmentResults'
import SelectionIndicator from '@/components/svgs/SelectionIndicator'
import { Dialog, DialogClose, DialogContent, DialogTrigger } from '@/ui/core/dialog'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Pressable } from '@/ui/primitives/slot'
import { type Href, Link, usePathname } from 'expo-router'
import { useWindowDimensions } from 'react-native'

const MobileNavigationLink = ({ label, path }: { label: string; path: Href }) => (
	<DialogClose asChild>
		<Link href={path}>
			<Text className="text-color-palette_6 text-3xl font-primary-demi tracking-widest">
				{label}
			</Text>
		</Link>
	</DialogClose>
)

const MobileNavigationMenu = () => {
	const { hasAppointmentResults, isLoadingResults } = useFetchLatestAppoinmentResults()

	if (isLoadingResults) {
		return null
	}

	return (
		<Dialog>
			<DialogTrigger asChild>
				<Pressable className="p-8 native:top-6 z-30">
					<Text className="text-palette_6 font-primary-demi" spacing="wide" size="xl">
						MENU
					</Text>
				</Pressable>
			</DialogTrigger>
			<DialogContent variant="nav" contentClassName="w-full" showLogo={false}>
				<VStack className="justify-center items-center" gap={48}>
					<MobileNavigationLink label="HOME" path="/" />
					<MobileNavigationLink label="BILLING" path="/billing" />
					<MobileNavigationLink label="PROFILE" path="/profile" />
					{hasAppointmentResults && (
						<MobileNavigationLink label="MY SMILE" path="/my-smile" />
					)}
				</VStack>
			</DialogContent>
		</Dialog>
	)
}

const LargeNavigationLink = ({
	label,
	path,
	isActive,
}: { label: string; path: Href; isActive: boolean }) => (
	<Link href={path}>
		<VStack className="items-center">
			<Text className="text-xl text-palette_6 font-primary-demi" spacing="wide">
				{label}
			</Text>
			{isActive && <SelectionIndicator width={'100%'} />}
		</VStack>
	</Link>
)

const LargeNavigationView = () => {
	const pathname = usePathname()
	const { hasAppointmentResults, isLoadingResults } = useFetchLatestAppoinmentResults()

	if (isLoadingResults) {
		return null
	}

	return (
		<HStack gap={36} className="z-30 pr-8">
			<LargeNavigationLink label="HOME" path="/" isActive={pathname === '/'} />
			<LargeNavigationLink
				label="BILLING"
				path="/billing"
				isActive={pathname === '/billing'}
			/>
			<LargeNavigationLink
				label="PROFILE"
				path="/profile"
				isActive={pathname === '/profile'}
			/>
			{hasAppointmentResults && (
				<LargeNavigationLink
					label="MY SMILE"
					path="/my-smile"
					isActive={pathname === '/my-smile'}
				/>
			)}
		</HStack>
	)
}

const AppNavigation = () => {
	const { width } = useWindowDimensions()

	const showMobileNav = width < 800

	return (
		<>
			{showMobileNav && <MobileNavigationMenu />}
			{!showMobileNav && <LargeNavigationView />}
		</>
	)
}

export { AppNavigation }
